export default __webpack_public_path__ + "assets/joel.86416b19.png";